module.exports = __webpack_public_path__ + "img/FinanceStatistic.9721257a.svg";